<template>
  <div class="advantage">
    <h1>{{$t('home.advantageTitlt')}}</h1>
    <div class="advantage_items">
      <img src="@/assets/images/hx_meiti.png" alt />
      <div>
        <p>{{$t('home.advantageTitlt3')}}</p>
        <p>{{$t('home.advantageContent3')}}</p>
      </div>
    </div>
    <div class="advantage_items">
      <img src="@/assets/images/hx_nncy.png" alt />
      <div>
        <p>{{$t('home.advantageTitlt2')}}</p>
        <p>{{$t('home.advantageContent2')}}</p>
      </div>
    </div>
    <div class="advantage_items">
      <img src="@/assets/images/hx_js.png" alt />
      <div>
        <p>{{$t('home.advantageTitlt1')}}</p>
        <p>{{$t('home.advantageContent1')}}</p>
      </div>
    </div>
    <div class="advantage_items">
      <img src="@/assets/images/hx_td.png" alt />
      <div>
        <p>{{$t('home.advantageTitlt4')}}</p>
        <p>{{$t('home.advantageContent4')}}</p>
      </div>
    </div>
    <div class="advantage_items">
      <img src="@/assets/images/hx_ggkh.png" alt />
      <div>
        <p>{{$t('home.advantageTitlt5')}}</p>
        <p>{{$t('home.advantageContent5')}}</p>
      </div>
    </div>
    <div class="advantage_items">
      <img src="@/assets/images/hx_cpcx.png" alt />
      <div>
        <p>{{$t('home.advantageTitlt6')}}</p>
        <p>{{$t('home.advantageContent6')}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.advantage {
  padding: 36px 20px 47px;
  & > h1 {
    margin-bottom: 24px;
  }
  & .advantage_items:last-child {
    margin-bottom: 0px;
  }
  & .advantage_items {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    & img {
      width: 44px;
      height: 44px;
      margin-right: 16px;
    }
    & > div {
      flex: 1;
      & > p:first-child {
        font-size: 16px;
        color: #000000;
        letter-spacing: 0;
        margin-bottom: 5px;
      }
      & > p:last-child {
        font-size: 12px;
        color: #666666;
        letter-spacing: 0;
        line-height: 20px;
      }
    }
  }
}
</style>